import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { selectFilterOptions } from "@/feature/flight/search/state/selectors";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { memo } from "react";
import {
  setFilters,
} from "@/feature/flight/search/state/slices/extract-flight-filter.slice";
import AccordionSection from "./accordion-section";

const Stoppage = memo(() => {
  const dispatch = useAppDispatch();
  const isResponseEnd = useAppSelector((state) => state.flightSearchStatus.isResponseEnd);
  const { selectOption, defaultOption } = useAppSelector(
    selectFilterOptions,
  );

  const leg_descriptions = defaultOption?.leg_descriptions || [];
  const max_stoppage_per_leg = defaultOption?.max_stoppage_per_leg || [];
  const selectedStoppages = selectOption?.stoppage || {};

  const handleChange = (legIndex: number, value: number) => {
    const currentSelected = selectedStoppages[legIndex] || [];
    const newSelected = currentSelected.includes(value)
      ? currentSelected.filter((v) => v !== value)
      : [...currentSelected, value];

    dispatch(
      setFilters({
        stoppage: {
          ...selectedStoppages,
          [legIndex]: newSelected,
        },
      }),
    );
  };

  if (!leg_descriptions.length) return null;

  return (
    <AccordionSection value="stoppage" label="Stoppage">
      <Tabs defaultValue="0">
        {leg_descriptions.length > 1 && (
          <TabsList className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 xl:grid-cols-4 gap-1 h-full! mb-3">
            {leg_descriptions.map((leg, index) => (
              <TabsTrigger
                key={index}
                value={index.toString()}
                className="text-[10px] truncate "
              >
                {leg.departureLocation} → {leg.arrivalLocation}
              </TabsTrigger>
            ))}
          </TabsList>
        )}

        {leg_descriptions.map((_, index) => {
          const maxStops = max_stoppage_per_leg[index] || 0;
          const selectedForLeg = selectedStoppages[index] || [];

          return (
            <TabsContent key={index} value={index.toString()}>
              <div className="space-y-3">
                {Array.from({ length: maxStops + 1 }, (_, i) => i).map(
                  (stopCount) => (
                    <div
                      key={stopCount}
                      className="flex items-center space-x-2"
                    >
                      <Checkbox
                        disabled={!isResponseEnd}
                        id={`stoppage-${index}-${stopCount}`}
                        checked={selectedForLeg.includes(stopCount)}
                        onCheckedChange={() => handleChange(index, stopCount)}
                      />
                      <Label
                        htmlFor={`stoppage-${index}-${stopCount}`}
                        className="font-normal cursor-pointer w-full"
                      >
                        {stopCount === 0
                          ? "Direct (0 stops)"
                          : stopCount === 1
                            ? "1 stop"
                            : `${stopCount} stops`}
                      </Label>
                    </div>
                  ),
                )}
                {/* {maxStops > 3 && (
                  <div className="flex items-center space-x-2">
                    <Checkbox
                      disabled={!isResponseEnd}
                      id={`stoppage-${index}-3plus`}
                      checked={selectedForLeg.some((count) => count >= 3)}
                      onCheckedChange={() => handleChange(index, 3)}
                    />
                    <Label
                      htmlFor={`stoppage-${index}-3plus`}
                      className="font-normal cursor-pointer w-full"
                    >
                      3+ stops
                    </Label>
                  </div>
                )} */}
              </div>
            </TabsContent>
          );
        })}
      </Tabs>
    </AccordionSection>
  );
});

Stoppage.displayName = "Stoppage";

export default Stoppage;


